import { render, staticRenderFns } from "./ProductCodes.vue?vue&type=template&id=620318f0&"
import script from "./ProductCodes.vue?vue&type=script&lang=js&"
export * from "./ProductCodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports